import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be7e960c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full relative flex justify-end px-1/24 mx-auto max-w-content z-40" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[90%] w-[90%] icon icon-arrow-up" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { ref, onMounted } from "vue";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollUp',
  setup(__props) {

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const scrollButton = ref<HTMLButtonElement | null>(null);

const scrollToTop = () => {
  gsap.to(window, {
    duration: 1,
    scrollTo: { y: 0, autoKill: true },
    ease: "power2.inOut",
  });
};

onMounted(() => {
  gsap.to(scrollButton.value, {
    autoAlpha: 0,
  });

  ScrollTrigger.create({
    trigger: document.body,
    start: "top+=1000 top",
    end: "bottom bottom",
    onEnter: () => {
      gsap.to(scrollButton.value, {
        autoAlpha: 1, pointerEvents: "auto"
      });
    },
    onLeaveBack: () => {
      gsap.to(scrollButton.value, {
        autoAlpha: 0, pointerEvents: "none"
      });
    },
    markers: false,

  })
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      ref_key: "scrollButton",
      ref: scrollButton,
      class: "rounded-full shadow-xl scroll-top-btn h-[5rem] w-[5rem] flex justify-center items-center fixed bottom-[4.1rem] md:bottom-[11.5rem] opacity-0 pointer-events-none transition-all duration-[400ms]",
      onClick: scrollToTop
    }, _hoisted_3, 512)
  ]))
}
}

})